import React from "react";
import Fallback from "../../components/Fallback";

const Compaigns = React.lazy(() => import("./Compaigns"));
export const CompaignsScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Compaigns {...props} />
  </React.Suspense>
);

const CompaignsDetail = React.lazy(() => import("./CompaignsDetail"));
export const CompaignsDetailScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <CompaignsDetail {...props} />
  </React.Suspense>
);
